export const STATUS_COLORS = {
  green: '#34A853',
  red: '#ff4757',
  gray: '#e0e0e0',
};

export const getStatusHex = (colorName) => {
  if (!colorName) return STATUS_COLORS.gray;
  if (colorName === 'orange' || colorName === 'yellow') return STATUS_COLORS.red;
  return STATUS_COLORS[colorName] || colorName || STATUS_COLORS.gray;
};

export const getWorstStatusColor = (colors = []) => {
  if (!Array.isArray(colors) || colors.length === 0) return STATUS_COLORS.gray;
  const normalized = colors.map(getStatusHex);
  if (normalized.includes(STATUS_COLORS.red)) return STATUS_COLORS.red;
  if (normalized.includes(STATUS_COLORS.green)) return STATUS_COLORS.green;
  return STATUS_COLORS.gray;
};

export const hasKnownData = (value) =>
  value !== null && value !== undefined && value !== '' && value !== '-';
